module.exports = __webpack_public_path__ + "static/media/horrormax-banner-on-the-brain.513e08a9.jpg";